// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBFk9OXA8HCxMGL-b0FFeoWs1DbbsfKgZk",
  authDomain: "horemowghana-e5336.firebaseapp.com",
  databaseURL: "https://horemowghana-e5336-default-rtdb.firebaseio.com",
  projectId: "horemowghana-e5336",
  storageBucket: "horemowghana-e5336.appspot.com",
  messagingSenderId: "577117224477",
  appId: "1:577117224477:web:29d0d083329354f4be10f4",
  measurementId: "G-8HEYTQMXKF"
};

const app = initializeApp(firebaseConfig);
 const db = getFirestore(app);
export const realtimeDB = getDatabase(app);
export const storage = getStorage();
export default db;
// eslint-disable-next-line
const analytics = getAnalytics(app);